import React from 'react';
import { compose } from 'ramda';
import styleFile from './header.js';
import { Button } from '@synergycms_core/components/generic';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';


const SearchButton = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  const { availInfoTheme } = props;

  const richTextProps = {
    translate: true,
  }

  if (availInfoTheme === 'minimal') {
    richTextProps.innerStyle= ['uppercase'];
    richTextProps.text = '_%modificar%_';
    if(props.theme.width <= 1200) {
      richTextProps.text = '';
      richTextProps.icon = {
        content: '',
        innerStyle: ['size17', classes.pencilIcon]
      };
    }
  } else {
    richTextProps.innerStyle= ['uppercase', classes.buttonText];
    richTextProps.icon = {
      content: '',
      innerStyle: ['size17', classes.pencilIcon]
    };

    if(props.theme.width > 1100) {
      richTextProps.text = '_%modificar búsqueda%_';
      richTextProps.icon.innerStyle = ['uppercase', 'size17', classes.pencilIcon];
    }
  }


  return (
    <div className={classes.modifySearch}>
      <Button
        onClick={props.onClick}
        richText={richTextProps}
        translate={true}
        innerStyle={['toggleMainButtonReverse', availInfoTheme === 'minimal' ? classes.minModifySearchBtn : '']}
      />
    </div>
  );
});

export default SearchButton;